module.exports = __webpack_public_path__ + "static/media/road-king-special-metallic.56dbb2cd.png";